import React from 'react';
import { Table, } from 'react-bootstrap';
import moment from 'moment-timezone';
import SubtleBadge from 'components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import nl2br from 'react-nl2br';

import HabilitationService from 'services/habilitationsService';
import IconButton from 'components/common/IconButton';

const DemandeDPSStep5 = ({
    watch1,
    watch2,
    watch3,
    watch4,
    jumpToStep,
}) => {
    return (<>
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center>
                <h5 className='text-primary mb-2'>Vous en tant qu'organisateur</h5>
            </center>

            <Table bordered size='sm'>
                <tbody>
                    {HabilitationService.habilitations && watch1("idStructureClient") ?
                        <tr key={'ligne1'}>
                            <th>Compte client</th>
                            <td>{watch1("idStructureClient").nomStructureClient}</td>
                        </tr>
                    :
                        <tr key={'ligne2'}>
                            <th>Organisateur</th>
                            <td>
                                Raison sociale: {watch1("orgaRaisonSociale")}<br/>
                                Adresse: {watch1("orgaAdresse")}<br/>
                                Représentant légal: {watch1("orgaRepresentantLegal")} - {watch1("orgaRepresentantLegalFonction")} - {watch1("orgaRepresentantLegalMail")} - {watch1("orgaRepresentantLegalTel")}<br/>
                                Facturation: {watch1("orgaFacturationMail")} - {watch1("orgaFacturationTel")}
                            </td>
                        </tr>
                    }

                    <tr key={'ligne3'}>
                        <th style={{ width: '25%' }}>Dossier suivi par</th>
                        <td>
                            Identité: {watch1("orgaRepresentePar")}<br/>
                            Fonction: {watch1("orgaRepresenteParFonction")}<br/>
                            Mail: {watch1("orgaRepresenteParMail")}<br/>
                            Téléphone: {watch1("orgaRepresenteParTel")}
                        </td>
                    </tr>

                    <tr key={'ligne4'}>
                        <th>Contact sur place le jour J</th>
                        <td>
                            Identité: {watch1("orgaContactLocal")}<br/>
                            Fonction: {watch1("orgaContactLocalFonction")}<br/>
                            Téléphone: {watch1("orgaContactLocalTel")}
                        </td>
                    </tr>
                </tbody>
            </Table>

            <center>
                <IconButton
                    variant='outline-warning'
                    icon='pencil'
                    size='sm'
                    onClick={()=>{jumpToStep(1)}}
                >Modifier</IconButton>
            </center>
        </div>

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center>
                <h5 className='text-primary mb-2'>Votre évènement</h5>
            </center>

            <Table bordered size='sm'>
                <tbody>
                    <tr key={'ligne5'}>
                        <th style={{ width: '25%' }}>Evenement</th>
                        <td>{watch2("libelleEvenement")}</td>
                    </tr>
                    <tr key={'ligne6'}>
                        <th>Activité</th>
                        <td>{watch2("activiteEvenement")}</td>
                    </tr>
                    <tr key={'ligne7'}>
                        <th>Date</th>
                        <td>{moment(watch2("dateDebutEvenement")).format('dddd DD MMMM YYYY')}</td>
                    </tr>

                    <tr key={'ligne8'}>
                        <th>Lieu de l'évènement</th>
                        <td>
                            {watch2("manifNomLieu")}<br/>
                            {watch2("manifAdresse")}<br/>
                            {watch2("manifCP")} {watch2("manifVille")}<br/>
                            {watch2("manifInternational") ? <SubtleBadge bg='warning'>ASPECT INTERNATIONAL</SubtleBadge> : <SubtleBadge bg='secondary'>En France uniquement</SubtleBadge>}
                        </td>
                    </tr>

                    <tr key={'ligne9'}>
                        <th>Caractéristiques du lieu</th>
                        <td>
                            Sur voie publique: {watch2("manifSurVP") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Voie publique fermée à la circulation: {watch2("manifSurVPFermee") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Sur circuit: {watch2("manifCircuit") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Circuit entièrement carrossable: {watch2("manifCircuitCarrossable") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Score E1 d'accessibilité (calculé): {watch2("manifE1Accessibilite")}<br/>
                            Score E2 secours publics (calculé): {watch2("manifE2DelaisSP")}<br/>
                            Pompiers de proximité: {watch2("manifSPproches")}<br/>
                            Centre hospitalier de proximité: {watch2("manifCHUproches")}<br/>
                            Risques particuliers: {nl2br(watch2("manifRisqueSite"))}<br/>
                            Remarques: {nl2br(watch2("manifRemarques"))}
                        </td>
                    </tr>

                    <tr key={'ligne10'}>
                        <th>Autres services sur place</th>
                        <td>
                            Autre AASC: {watch2("accueilAutreAASC") ? watch2("accueilAutreAASCDetails") : <FontAwesomeIcon icon='close'/>}<br/>
                            SME: {watch2("accueilSME") ? watch2("accueilSMEDetails") : <FontAwesomeIcon icon='close'/>}<br/>
                            Médical hors SME: {watch2("accueilMedicalAutreSME") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Ambulance privée: {watch2("accueilAP") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            SAMU: {watch2("accueilSAMU") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Pompiers: {watch2("accueilSP") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Sécurité Privée: {watch2("accueilSecuPrivee") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Forces de l'ordre: {watch2("accueilFDO") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}
                        </td>
                    </tr>

                    <tr key={'ligne11'}>
                        <th>Conditions d'accueil</th>
                        <td>
                            Radio fournie: {watch2("accueilRadioOrga") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Locaux en dur dédiés aux Postes de Secours: {watch2("accueilLocauxIS") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Tentes dédiées aux Postes de Secours: {watch2("accueilTenteIS") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Electricité: {watch2("accueilElectricite") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Eau courante: {watch2("accueilEau") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Chauffage/Climatisation: {watch2("accueilChauffage") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Lumière: {watch2("accueilLumiere") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Mobilier à disposition: {nl2br(watch2("accueilMobilierIS"))}<br/>
                            Repas fournis: {watch2("accueilRepas") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Eau pour plans forte chaleur: {watch2("accueilEauCanicule") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                            Local repos secouristes: {watch2("accueilReposIS") ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}
                        </td>
                    </tr>
                </tbody>
            </Table>

            <center>
                <IconButton
                    variant='outline-warning'
                    icon='pencil'
                    size='sm'
                    onClick={()=>{jumpToStep(2)}}
                >Modifier</IconButton>
            </center>
        </div>

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center>
                <h5 className='text-primary mb-2'>Le découpage horaire</h5>
            </center>
            
            {watch3("parties").map((partie, i)=>{return(<>
                <Table bordered size='sm'>
                    <tbody>
                        <tr key={'ligne12'}>
                            <th colSpan={"2"}><center>Partie #{i+1}</center></th>
                        </tr>
                        <tr key={'ligne13'}>
                            <th style={{ width: '25%' }}>Horaires de l'évènement</th>
                            <td>
                                Début: {moment(partie.dateDebutPartieEvenement).format("DD/MM/YYYY HH:mm")}<br/>
                                Fin: {moment(partie.dateFinPartieEvenement).format("DD/MM/YYYY HH:mm")}
                            </td>
                        </tr>
                        <tr key={'ligne14'}>
                            <th>Horaires de présence des secouristes</th>
                            <td>
                                Début: {moment(partie.dateDebutPartieSecours).format("DD/MM/YYYY HH:mm")}<br/>
                                Fin: {moment(partie.dateFinPartieSecours).format("DD/MM/YYYY HH:mm")}
                            </td>
                        </tr>
                        <tr key={'ligne15'}>
                            <th>Public</th>
                            <td>
                                Effectif attendu: {partie.effectifPublicP1}<br/>
                                Score P2 comportement public (calculé): {partie.typePublicP2}<br/>
                                Vente Alcool: {partie.venteAlcool ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                Risques particuliers: {nl2br(partie.risquesPublic)}
                            </td>
                        </tr>
                        <tr key={'ligne16'}>
                            <th>Acteurs</th>
                            <td>
                                Effectif attendu: {partie.effectifActeurs}<br/>
                                Activité: {partie.activiteActeurs}<br/>
                                Risques particuliers: {nl2br(partie.risquesActeurs)}
                            </td>
                        </tr>
                        <tr key={'ligne17'}>
                            <th>Autres risques</th>
                            <td>
                                Pyrotechnie: {partie.pyrotechnie ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}<br/>
                                Engins motorisés: {partie.enginsMotrises ? <FontAwesomeIcon icon='check'/> : <FontAwesomeIcon icon='close'/>}
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <hr/></>
            )})}

            <center>
                <IconButton
                    variant='outline-warning'
                    icon='pencil'
                    size='sm'
                    onClick={()=>{jumpToStep(3)}}
                >Modifier</IconButton>
            </center>
        </div>
        
        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
            <center>
                <h5 className='text-primary mb-2'>La documentation</h5>
            </center>

            {watch4("files") && watch4("files").length > 0 ?
                <ul>
                    {watch4("files").map((file, i)=>{return(
                        <li key={i}>{file.name}</li>
                    )})}
                </ul>
            :
                <i>Aucun fichier partagé</i>
            }

            <center>
                <IconButton
                    variant='outline-warning'
                    icon='pencil'
                    size='sm'
                    onClick={()=>{jumpToStep(4)}}
                >Modifier</IconButton>
            </center>
        </div>
    </>);
};


DemandeDPSStep5.propTypes = {};

export default DemandeDPSStep5;